import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../../../Tag'

function ViewingCalendarItemTag({ item }) {
  return (
    <Tag
      appearance={TAG_APPEARANCE.filled}
      height={TAG_HEIGHT.height24}
      text={item.popover.kindLabel}
    />
  )
}

export default ViewingCalendarItemTag
